import styled, { css } from 'styled-components'
import { Container } from 'src/components/common/Container'
import { ellip, mediaMaxWidth } from 'src/styles/mixin'
import { Typography } from 'src/components/common/Typography'
import {
  Noto_body1_r16,
  Noto_body2_r14,
  Noto_body3_r12,
  Noto_subheading_b18,
} from 'src/styles/fonts/NotoSansKrFonts'
import { Roboto_num1_b20, Roboto_num3_r14, Roboto_num4_b12 } from 'src/styles/fonts/RobotoFonts'
import { MainPageProps } from 'src/pages/MainPage'
import { SmallDivider } from 'src/components/common/Divider'
import HotDealPreceed from 'src/pages/MainPage/_components/FloatItemHotDealCoupon/HotDealPreceed'
import hotdeal_soldout_tag from 'src/assets/images/main/hotdeal_soldout_tag.png'
import React from 'react'
import RenderIf from 'src/components/common/RenderIf'
import HotDealComingSoon from 'src/pages/MainPage/_components/FloatItemHotDealCoupon/HotDealCommingSoon'
import LazyImage from 'src/components/common/LazyImage'
import usePageNav from 'src/hooks/usePageNav.hook'
import Skeleton from 'react-loading-skeleton'

const MainHotDealCoupon = ({ hotDealCouponList }: MainPageProps) => {
  const { hotDealDetailPageNav } = usePageNav()
  const inProgressCoupon = hotDealCouponList?.filter((w) => w.SellFlag !== 1)
  const incomingCoupon = hotDealCouponList?.filter((w) => w.SellFlag === 1)

  return (
    <S.HotDealCoupon.Container $option="flex_column" $row_gap="30px">
      {/*진행, 품절 핫딜*/}
      <S.HotDealCoupon.InProgress.Container $option="flex_column" $row_gap="20px">
        <S.HotDealCoupon.Title.Container $option="flex_row" $column_gap="4px">
          <S.HotDealCoupon.Title.Point $fontStyle={Roboto_num4_b12} $color="var(--white)">
            HOT
          </S.HotDealCoupon.Title.Point>
          <S.HotDealCoupon.Title.Text $fontStyle={Noto_subheading_b18}>
            오늘의 핫딜
          </S.HotDealCoupon.Title.Text>
        </S.HotDealCoupon.Title.Container>
        <RenderIf when={inProgressCoupon?.length === 0}>
          <S.HotDealCoupon.EmptyCouponLists $option="flex_column">
            <Typography $fontStyle={Noto_body1_r16} $color="var(--black-30)">
              상품을 준비중입니다.
            </Typography>
          </S.HotDealCoupon.EmptyCouponLists>
        </RenderIf>
        <RenderIf when={inProgressCoupon?.length !== 0}>
          <Container $option="flex_column" $row_gap="30px">
            {inProgressCoupon?.map(
              (
                {
                  CouponImage,
                  DiscountRate,
                  RegularPrice,
                  SalePrice,
                  CouponName,
                  EndDT,
                  SellFlag,
                  CouponNumber,
                  CouponIdx,
                },
                i_i,
              ) => {
                const handleHotDealDetailPage = () =>
                  SellFlag !== 2 && hotDealDetailPageNav(`${CouponNumber}`, CouponIdx)

                return (
                  <S.HotDealCoupon.InProgress.Items.Card
                    $option="flex_column"
                    key={i_i}
                    onClick={handleHotDealDetailPage}
                  >
                    <LazyImage
                      src={CouponImage}
                      alt="쿠폰 이미지"
                      style={S.HotDealCoupon.InProgress.Items.Image(SellFlag === 2)}
                    />
                    <RenderIf when={SellFlag === 0}>
                      <HotDealPreceed EndDT={EndDT} position={{ t: '-45px', l: '8px' }} />
                    </RenderIf>
                    <RenderIf when={SellFlag === 2}>
                      <S.HotDealCoupon.InProgress.SoldOutContents.Container $option="flex_column">
                        <S.HotDealCoupon.InProgress.SoldOutContents.Fence />
                      </S.HotDealCoupon.InProgress.SoldOutContents.Container>
                    </RenderIf>
                    <RenderIf when={!!SalePrice}>
                      <S.HotDealCoupon.InProgress.Items.PriceInfo
                        $option="flex_row"
                        $column_gap="4px"
                      >
                        <S.HotDealCoupon.InProgress.Items.DiscountRate
                          $fontStyle={Roboto_num1_b20}
                          $color="var(--brand-50)"
                        >
                          {Math.floor((DiscountRate as number) * 10) / 10}%
                        </S.HotDealCoupon.InProgress.Items.DiscountRate>
                        <S.HotDealCoupon.InProgress.Items.SalePrice
                          $fontStyle={Roboto_num1_b20}
                          $color="var(--black-90)"
                          as={!!SalePrice ? Typography : Skeleton}
                        >
                          {SalePrice?.toLocaleString()}원
                        </S.HotDealCoupon.InProgress.Items.SalePrice>
                        <S.HotDealCoupon.InProgress.Items.RegularPrice
                          $fontStyle={Roboto_num3_r14}
                          $color="var(--black-30)"
                        >
                          {RegularPrice?.toLocaleString()}원
                        </S.HotDealCoupon.InProgress.Items.RegularPrice>
                      </S.HotDealCoupon.InProgress.Items.PriceInfo>
                      <S.HotDealCoupon.InProgress.Items.CouponName
                        $fontStyle={Noto_body2_r14}
                        $color="var(--black-90)"
                      >
                        {CouponName}
                      </S.HotDealCoupon.InProgress.Items.CouponName>
                    </RenderIf>
                    <RenderIf when={!SalePrice}>
                      <Skeleton count={2} style={{ marginBottom: '5px' }} />
                    </RenderIf>
                  </S.HotDealCoupon.InProgress.Items.Card>
                )
              },
            )}
          </Container>
        </RenderIf>
      </S.HotDealCoupon.InProgress.Container>
      <SmallDivider />
      {/*진행 예정 핫딜*/}
      <RenderIf when={incomingCoupon?.length !== 0}>
        <S.HotDealCoupon.InComing.Container $option="flex_column" $row_gap="16px">
          <Container $option="flex_column" $row_gap="16px">
            <S.HotDealCoupon.Title.Container $option="flex_row">
              <S.HotDealCoupon.Title.Text $fontStyle={Noto_subheading_b18}>
                ⏳오픈 직전 핫딜
              </S.HotDealCoupon.Title.Text>
            </S.HotDealCoupon.Title.Container>
            <Container $option="flex_column" $row_gap="16px">
              {incomingCoupon?.map(({ CouponName, CouponImage, StartDT }) => (
                <S.HotDealCoupon.InComing.Items.Card
                  $option="flex_row"
                  $column_gap="10px"
                  key={CouponName}
                >
                  <LazyImage
                    src={CouponImage}
                    alt="쿠폰 이미지"
                    style={S.HotDealCoupon.InComing.Items.Image}
                  />
                  <S.HotDealCoupon.InComing.Items.CouponInfo $option="flex_column" $row_gap="4px">
                    <HotDealComingSoon StartDT={StartDT} />
                    <S.HotDealCoupon.InComing.Items.CouponName
                      $fontStyle={Noto_body3_r12}
                      $color="var(--black-50)"
                    >
                      {CouponName}
                    </S.HotDealCoupon.InComing.Items.CouponName>
                  </S.HotDealCoupon.InComing.Items.CouponInfo>
                </S.HotDealCoupon.InComing.Items.Card>
              ))}
            </Container>
          </Container>
        </S.HotDealCoupon.InComing.Container>
      </RenderIf>
    </S.HotDealCoupon.Container>
  )
}
export default MainHotDealCoupon

const S = {
  HotDealCoupon: {
    Container: styled(Container)`
      font-size: 30px;
      font-weight: bold;
      justify-content: center;
      align-items: center;
      text-align: center;
      max-width: 420px;
      margin: 0 auto;
      background-color: var(--white);

      ${mediaMaxWidth('460')} {
        max-width: unset;
        padding: 0 20px;
      }
    `,
    EmptyCouponLists: styled(Container)`
      justify-content: center;
      text-align: center;
      padding: 100px 0;
      flex: 1;
    `,
    EmptyIcon: styled.img``,
    Title: {
      Container: styled(Container)`
        align-items: center;
      `,
      Text: styled(Typography)``,
      Point: styled(Typography)`
        display: flex;
        border-radius: 4px;
        background: linear-gradient(180deg, #6001fc 0%, #0271fe 100%);
        padding: 4px 6px;
        line-height: 12px;
        width: fit-content;
        height: fit-content;
      `,
    },
    InProgress: {
      Container: styled(Container)``,

      Items: {
        Card: styled(Container)`
          cursor: pointer;
        `,
        PriceInfo: styled(Container)`
          align-items: center;
        `,
        Image: (disabled: boolean) => css`
          width: 100%;
          height: 220px;
          border-radius: 20px;
          padding: 0.5px;
          margin-bottom: 12px;
          img {
            border: 1px solid rgba(0, 0, 0, 0.01);
            width: 100%;
            height: 220px;
            object-fit: cover;
            object-position: center;
            border-radius: 20px;
          }
          ${disabled &&
          css`
            cursor: default;
          `}
        `,
        DiscountRate: styled(Typography)``,
        SalePrice: styled(Typography)``,
        RegularPrice: styled(Typography)`
          text-decoration: line-through;
        `,
        CouponName: styled(Typography)`
          text-align: left;
        `,
      },
      SoldOutContents: {
        Container: styled(Container)`
          height: 0;
          width: 100%;
          justify-content: center;
          pointer-events: none;
        `,
        Fence: styled.section`
          display: flex;
          position: relative;
          top: -120px;
          z-index: 2;
          background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%);
          border-radius: 20px;
          &:after {
            content: '';
            width: 100%;
            height: 220px;
            background: url(${hotdeal_soldout_tag}) no-repeat center;
            background-size: 170px 170px;
          }
        `,
      },
    },
    InComing: {
      Container: styled(Container)``,
      Items: {
        Card: styled(Container)`
          height: 120px;
        `,
        CouponInfo: styled(Container)`
          height: 100%;
          justify-content: center;
        `,
        Image: css`
          min-width: 120px;
          border: 1px solid rgba(0, 0, 0, 0.01);
          width: auto;
          height: 100%;
          border-radius: 12px;
          &:hover {
            transform: scale(1.05);
          }
        `,
        CouponName: styled(Typography)`
          ${ellip('line2')};
        `,
      },
    },
  },
}
